import * as Yup from 'yup';

export const SignInSchema = Yup.object().shape({
  username: Yup.string().email().required('Username is required'),
  password: Yup.string().min(8).required('Please provide a your password'),
});

export type SignInDataType = Yup.InferType<typeof SignInSchema>;

type InitialValues = {
  username: string;
  password: string;
};

export const signinInitialValues: InitialValues = {
  username: '',
  password: '',
};

export interface IUserData {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  warehouseId: string;
  warehouseRole: string;
  verified: boolean;
  phoneNumber: string;
}

export interface IsignInData {
  user: IUserData;
  token: string;
}
